import { useEffect, useState } from "react";
import { useForm } from "../../utility/useForm";
import { PadvishRequestLicenseForm } from "../../utility/validationRules";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { useLocation, useNavigate } from "react-router-dom";
import { ValidationErrorSpan } from "../../styles/global";
import {  insertPadvishRequestLicense } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import {StyledContainer } from "./styles";
import FormContainer from "../../components/FormContainer/FormContainer";
import { Col, Row } from "antd";
import Input from "../../components/_common/Input";

const NewPadvishRequestLicense = () => {
    const {state} = useLocation();
    const { requestId,accountId } = state; // Read values passed on state
    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(PadvishRequestLicenseForm) as any
    const [isLoading,setIsLoading] = useState(false);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(()=>{
        // insertPadvishRequestLicense(4,"computerName","consoleComputerIp","consoleVersion","2023-12-12","license",19)
        // .then((result:any) => {
        //     console.log(result);
        //     setIsSubmiting(false)
        //     navigate("/" + myStore.auth.loginType + "/padvishLicenseRegistration");
        //     sucessNotify("ثبت با موفقیت انجام شد")
        // })
        // .catch((error) => {
        //     setIsSubmiting(false)
        //     errorNotify(error.response.data.errorMessage,undefined,5000)
        // })

    },[])

 
    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    const FormSubmit = (e:any) => {
        e.preventDefault();
        
        let error= PadvishRequestLicenseForm(values);
        if (Object.keys(error).length == 0)
        {
            setIsSubmiting(true)

            insertPadvishRequestLicense(requestId,accountId,values.consoleComputerName,values.consoleComputerIp,values.consoleVersion,values.expireDate,values.license,Number(values.licenseCount)?Number(values.licenseCount):0 )
            .then((result:any) => {
                console.log(result);
                setIsSubmiting(false)
                navigate("/" + myStore.auth.loginType + "/padvishLicenseRegistration", { state: { requestId} });
                sucessNotify("ثبت با موفقیت انجام شد")
            })
            .catch((error) => {
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage,undefined,5000)
            })

        }
        else
        {
          setErrors(error);
        }
        
    }

    return(
        <StyledContainer>

           <FormContainer title="درخواست لایسنس ویروس کنترل پادویش" onSubmit={FormSubmit} isLoading={isLoading} isSubmiting={isSubmiting}  > 
                    <Row>
                        <Col lg={8} md={8} sm={12} xs={24}>                           
                            <Input
                                type="text"
                                name="consoleComputerName"
                                placeholder="نام کامپیوتر"
                                value={values.consoleComputerName || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="consoleComputerName" />             
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={24}>                           
                            <Input
                                type="text"
                                name="consoleComputerIp"
                                placeholder="IP کامپیوتر"
                                value={values.consoleComputerIp || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="consoleComputerIp" />             
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={24}>                           
                            <Input
                                type="text"
                                name="consoleVersion"
                                placeholder="ورژن"
                                value={values.consoleVersion || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="consoleVersion" />             
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={8} md={8} sm={12} xs={24}>                           
                            <Input
                                type="text"
                                name="expireDate"
                                placeholder="تاریخ انقضا"
                                value={values.expireDate || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="expireDate" />             
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={24}>                           
                            <Input
                                type="text"
                                name="license"
                                placeholder="کد لایسنس"
                                value={values.license || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="license" />             
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={24}>                           
                            <Input
                                type="text"
                                name="licenseCount"
                                placeholder="تعداد کاربر"
                                value={values.licenseCount || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="licenseCount" />             
                        </Col>
                    </Row>
           </FormContainer>

        </StyledContainer>
    )
}

export default NewPadvishRequestLicense;